import { render, staticRenderFns } from "./HowToApply.vue?vue&type=template&id=abd498dc"
import script from "./HowToApply.vue?vue&type=script&lang=ts"
export * from "./HowToApply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports